/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brand: NonNullable<unknown> }} Palette_Open_BrandInputs */

const en_palette_open_brand = /** @type {(inputs: Palette_Open_BrandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open ${i?.brand}`)
};

/**
* | output |
* | --- |
* | "Open {brand}" |
*
* @param {Palette_Open_BrandInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_open_brand = /** @type {((inputs: Palette_Open_BrandInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Open_BrandInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_open_brand(inputs)
});